import Box from '@mui/material/Box';
import Stack from '@mui/material/Stack';
import { GradientTypography } from '../../gradients/GradientTypography';
import { GradientBorder } from 'src/components/gradients/GradientBorder';
import { useNumberFormatter } from 'src/hooks/useNumberFormatter';
import { ResultRanked } from './HeatLeaderboard';
import { FeaturedCompetitor } from 'src/components/leaderboards/FeaturedCompetitor';
import { ScoreOption } from 'functions/src/types/firestore/Game/Competition';
import { Link } from 'src/components/Link';

export type HeatTop3Props = {
  top3Results: Omit<ResultRanked, 'userIds'>[];
  scoreOption?: ScoreOption;
};

export function HeatTop3({ top3Results, scoreOption }: HeatTop3Props) {
  const formatter2Digits = useNumberFormatter({
    minimumIntegerDigits: 2,
  });
  const formatterStandard = useNumberFormatter({
    notation: 'standard',
  });

  function format(score = 0): string {
    if (scoreOption?.units === 's') {
      return `${Math.floor(score / 60)}:${formatter2Digits.format(score % 60)}`;
    }
    return formatterStandard.format(score);
  }

  return (
    <Box>
      <GradientTypography
        gradientColor="primary.vertical"
        variant="h5"
        sx={{
          mb: 1,
          ml: 3,
        }}
      >
        TOP 3
      </GradientTypography>

      <GradientBorder
        sx={{
          borderRadius: '10px',
          width: 'auto',
        }}
      >
        <Stack
          flexDirection="row"
          justifyContent="center"
          alignItems="center"
          flexWrap="wrap"
          sx={{
            px: 4,
            pb: 2,
            minHeight: '160px',
          }}
        >
          {top3Results?.map(
            ({ imgUrl, name, prize, score, rank, userIdCaptain }) => {
              // TODO: replace these Links with profile previous when implemented
              const captainUrl = `/profile/${userIdCaptain}/inventory`;
              return (
                <Link
                  key={`${name}-${rank}`}
                  href={captainUrl}
                  sx={{ textDecoration: 'none' }}
                >
                  <FeaturedCompetitor
                    imgUrl={imgUrl}
                    name={name}
                    rank={rank}
                    prize={prize}
                    score={format(score)}
                    scoreSuffix={
                      scoreOption?.units !== 's'
                        ? scoreOption?.units
                        : scoreOption?.name || 'pts'
                    }
                  />
                </Link>
              );
            },
          )}
        </Stack>
      </GradientBorder>
    </Box>
  );
}
